export const SELECTEDCATEGORY = "filters/selectedCategory";
export const SELECTEDAUTHOR = "filters/selectedAuthor";
export const CLEARFILTER = "filters/clearFilter";
export const TYPEDINPUT = "filters/typedInput";
